module.exports = __webpack_public_path__ + "static/media/card-ai-agent-es.11e747ae.png";